import { Session } from "next-auth";
import { IconType } from "../components/icons/icon-props";
import Download from "../components/icons/lib/download";
import FilterIcon from "../components/icons/lib/filter-icon";
import SettingsIcon from "../components/icons/lib/settings";
import Coin from "../components/icons/lib/coin";
import UserIcon from "../components/icons/lib/user";

import { ACCOUNT_AUDIOLAB, ACCOUNT_PURCHASES, ACCOUNT_SALES_EARNINGS, ACCOUNT_SETTINGS, ACCOUNT_PROFILE, AUTH_LOGOUT, CREATORS, VIEW_CATEGORY } from "@/constants/routes";

export interface Link {
  id: string;
  name: string;
  href: string;
  visible?: (user: Session["user"]) => boolean;
  onClick?: (e?: MouseEvent) => void;
  icon?: IconType;
}

export const baseAuthLinks: Link[] = [
  {
    id: "account-link-uploads",
    name: "Audiolab",
    icon: FilterIcon,
    href: ACCOUNT_AUDIOLAB,
    visible: (user: Session["user"]) => user?.artistId !== null,
  },
  {
    id: "account-my-purchases",
    name: "My Purchases",
    icon: Download,
    href: ACCOUNT_PURCHASES,
  },
  {
    id: "account-sales-and-earnings",
    name: "Sales & Earnings",
    icon: Coin,
    href: ACCOUNT_SALES_EARNINGS,
    visible: (user: Session["user"]) => user?.artistId !== null,
  },
  {
    id: "account-link-settings",
    name: "Account Settings",
    icon: SettingsIcon,
    href: ACCOUNT_SETTINGS,
  },
];

export const authenticatedLinks: Link[] = [
  {
    id: "account-link-profile",
    name: "Profile",
    icon: UserIcon,
    href: ACCOUNT_PROFILE,
    visible: (user: Session["user"]) => user?.artistId !== null,
  },
  ...baseAuthLinks,
  {
    id: "account-link-logout",
    name: "Logout",
    href: AUTH_LOGOUT,
    visible: (user: Session["user"]) => user?.artistId !== null,
  },
];

export const discoverLinks = [
  {
    name: "Beats",
    href: {
      pathname: VIEW_CATEGORY,
      query: {
        category: 'beats'
      }
    }
  },
  {
    name: "Sounds",
    href: {
      pathname: VIEW_CATEGORY,
      query: {
        category: 'sounds'
      }
    }
  },
  {
    name: "Songs",
    href: {
      pathname: VIEW_CATEGORY,
      query: {
        category: 'songs'
      }
    }
  },
  {
    name: "Creators",
    href: CREATORS,
  },
];
